import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth callback, let AuthCallback handle it first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    if (!localStorage.getItem("errah_token")) {
      // still try cookie-based (google) session
      checkAuth();
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const loginLocal = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("errah_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const setSession = async (token) => {
    localStorage.setItem("errah_token", token);
    await checkAuth();
  };

  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("errah_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const partnerLogin = async (email, password) => {
    const { data } = await api.post("/auth/partner-login", { email, password });
    localStorage.setItem("errah_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const applicatorLogin = async (email, password) => {
    const { data } = await api.post("/applicator/login", { email, password });
    localStorage.setItem("errah_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("errah_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, loginLocal, signup, partnerLogin, applicatorLogin, setSession, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
